var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow",class:_vm.show ? 'arrow-left-side' : 'arrow-right-side',on:{"click":_vm.handleClick}},[_c('i',{staticClass:"glyphicons  x2",class:_vm.show ? 'glyphicons-chevron-right' : 'glyphicons-chevron-left'})])}
var staticRenderFns = []

export { render, staticRenderFns }